/**
 * PDP 附属交互玩法聚合（product 模板专属，stylesheets.liquid `{% when 'product' %}` defer 加载）。
 *
 * §1 评论星级 → 滑动到评论区：
 *    评级文本替换（评分代替评论数，custom.css 先隐藏防闪）+ 点击/键盘滚动到
 *    Judge.me 评论区；代理/自愈模式见 §8 规范。
 * §2 model-glass：主图模特信息毛玻璃框。
 *    数据 = product metafield custom.model_map（json，key=media 完整 gid → 多行文本，
 *    每行 `名字|身高|尺码|颜色way`），由 custom-promo-badges 块输出为
 *    <script type="application/json" data-product-model-map>。
 * 每节独立 IIFE + RIJ 命名空间分区，互不依赖。
 */
(function () {
  const NS = window.RIJ = window.RIJ || {};
  if (NS._reviewScrollWired) return;
  NS._reviewScrollWired = true;

  const REVIEW_TARGETS = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg';
  const RATING_SEL = '.rating-wrapper';

  function isOutsideReviewWidget(el) {
    return el && !el.closest('.jdgm-review-widget') && !el.closest('#judgeme_product_reviews');
  }

  function reviewTarget() {
    return document.querySelector(REVIEW_TARGETS);
  }

  // Desktop (>=990px) locks html/body and scrolls inside `.page-wrapper`
  // (base.css); smaller viewports scroll the window. Return the real
  // scroll container so scrollTo lands the same way on both.
  function getPageScroller() {
    const pw = document.querySelector('.page-wrapper');
    if (!pw) return null;
    return getComputedStyle(pw).overflowY !== 'visible' ? pw : null;
  }

  // Sticky-header clearance. On desktop the whole header group is pinned
  // above the page-wrapper scroller (announcement + header); on window-scroll
  // layouts only the sticky header stays put.
  function headerOffset() {
    const h = document.querySelector('header-component.header');
    const hdrH = h ? h.offsetHeight : 0;
    if (getPageScroller()) {
      const ann = document.querySelector('.announcement-bar, [class*="announcement-bar"]');
      return (ann ? ann.offsetHeight : 0) + hdrH + 20;
    }
    return hdrH + 20;
  }

  NS.wireReviewScroll = function wireReviewScroll() {
    [].slice.call(document.querySelectorAll(RATING_SEL)).forEach(function (el) {
      if (!isOutsideReviewWidget(el)) return;
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Scroll to customer reviews');
      renderRatingText(el);
    });
  };

  // Show the rating value ("4.6") instead of the review count. The count is
  // server-rendered but held invisible by custom.css until this runs, so no
  // wrong text ever paints. Value comes from Judge.me's in-page data; falls
  // back to the `Rated 4.x out of y` aria-label; last resort keeps the
  // original text and reveals it.
  function renderRatingText(wrapper) {
    const count = wrapper.querySelector('.rating-count');
    if (!count) return;
    let rating = null;

    const pid = (() => {
      const bar = document.querySelector('sticky-add-to-cart');
      if (bar && bar.dataset.productId) return bar.dataset.productId;
      const vp = document.querySelector('variant-picker');
      return vp && vp.dataset.productId ? vp.dataset.productId : null;
    })();
    try {
      const rw = pid && window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[pid];
      if (rw && rw.average_rating) rating = parseFloat(rw.average_rating);
    } catch (e) { /* jdgm absent — fall through */ }

    if (rating === null || isNaN(rating)) {
      const label = wrapper.querySelector('.rating[aria-label]');
      const m = label && label.getAttribute('aria-label').match(/(\d+(?:\.\d+)?)/);
      if (m) rating = parseFloat(m[1]);
    }

    if (rating !== null && !isNaN(rating)) {
      count.textContent = String(Math.round(rating * 10) / 10);
    }
    count.style.visibility = 'visible';
  }

  function goToReviews() {
    const target = reviewTarget();
    if (!target) return;
    const scroller = getPageScroller();
    const c = scroller || document.documentElement;
    const cRect = c.getBoundingClientRect();
    const top = target.getBoundingClientRect().top - cRect.top + (scroller ? scroller.scrollTop : window.scrollY) - headerOffset();
    const scroll = scroller ? scroller.scrollTo.bind(scroller) : window.scrollTo.bind(window);
    scroll({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    const el = e.target && e.target.closest ? e.target.closest(RATING_SEL) : null;
    if (!isOutsideReviewWidget(el)) return;
    goToReviews();
  }, true);

  document.addEventListener('keydown', function (e) {
    const el = document.activeElement;
    if (!el || !el.closest || !el.closest(RATING_SEL)) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!isOutsideReviewWidget(el)) return;
    e.preventDefault();
    goToReviews();
  }, true);

  // SPA color swaps replace sections wholesale and later morphs may re-strip
  // the attrs we set — watch childList AND the role attribute so a fresh or
  // re-stripped wrapper always gets re-wired (same self-healing pattern as
  // custom-promo-badges.js watching data-discounts).
  function needsWire() {
    return [].some.call(document.querySelectorAll(RATING_SEL), function (el) {
      return isOutsideReviewWidget(el) && el.getAttribute('role') !== 'link';
    });
  }

  let rewireTimer = null;
  const rewire = function () {
    if (rewireTimer) return;
    rewireTimer = setTimeout(function () {
      rewireTimer = null;
      if (needsWire()) NS.wireReviewScroll();
    }, 0);
  };
  new MutationObserver(rewire).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role'],
  });

  NS.wireReviewScroll();
})();

/* -------------------------------------------------------------------------
 * §2 model-glass — PDP 主图模特信息毛玻璃框（与"当前渲染的图片"严格绑定）。
 * 数据: product metafield custom.model_map (json: media 完整 gid → 多行文本,
 * 每行 `名字|身高|尺码|颜色way`), 由 blocks/custom-model-glass.liquid 输出为
 * <script type="application/json" data-product-model-map>。
 * 绑定策略: 每次刷新重读 map + 取当前激活图 (aria-hidden="false") 的 data-media-id,
 * 归一化 gid 后查表渲染; 无命中/无数据 → 隐藏(零视觉)。
 * 观察器挂在 document 级: 树变化(SPA 换色重建区块/新 script/切图 DOM) 和
 * aria-hidden 变化(图切换) 都能触发, 换产品后自动换到新品的 map。
 * ------------------------------------------------------------------------- */
(function () {
  const NS = window.RIJ = window.RIJ || {};
  if (NS._modelGlassWired) return;
  NS._modelGlassWired = true;

  const MAP_SEL = 'script[data-product-model-map]';
  const GALLERY_SCOPE = 'media-gallery slideshow-slide[aria-hidden="false"]';
  const BOX_ID = 'model-glass-box';

  function parseMap() {
    const node = document.querySelector(MAP_SEL);
    if (!node) return null;
    try {
      let v = JSON.parse(node.textContent || '{}');
      // json 类型 metafield 的 .value 若被 Liquid 输出为字符串, 再解一次
      if (typeof v === 'string') v = JSON.parse(v);
      return v && typeof v === 'object' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function mediaIdOf(el) {
    if (!el) return null;
    let mid = (el.getAttribute('data-media-id') || '').trim();
    if (!mid) return null;
    // data-media-id 是数字 id; 兼容完整 gid 取末段数字, 与新 metaobject 的 media_id 一致
    return mid.indexOf('gid://') === 0 ? mid.slice(mid.lastIndexOf('/') + 1) : mid;
  }

  function activeMedia() {
    const slide = document.querySelector(GALLERY_SCOPE);
    return slide ? slide.querySelector('[data-media-id]') : null;
  }

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function renderBox() {
    const map = parseMap(); // 每次刷新重读: 保证和当前页码/model_map 一一对应
    const media = activeMedia();
    const mid = mediaIdOf(media);
    const raw = map && mid ? map[mid] : null;
    // model_map 直接存"页面展示文案"(一行一模特), 这里只做原样输出, 不再是结构化解析
    const lines = String(raw || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    let box = document.getElementById(BOX_ID);
    const host = media ? media.closest('.product-media-container') : null;

    if (!lines.length) {
      if (box) box.hidden = true;
      return;
    }
    if (!box) {
      box = document.createElement('div');
      box.id = BOX_ID;
      box.className = 'model-glass';
    }
    // 单行紧凑条: 每行一条展示文案(如 "Model is 5'8\" wearing S"), 多模特用 " — " 拼接
    box.innerHTML = lines.map(function (line) {
      return '<span>' + esc(line) + '</span>';
    }).join('<span class="model-glass__sep"> — </span>');
    box.hidden = false;
    // 跟随激活图: 优先移入当前图片容器(已有 position:relative); 找不到容器时挂画廊根
    const target = host || document.querySelector('media-gallery') || document.body;
    if (box.parentElement !== target) target.appendChild(box);
  }

  let glassTimer = null;
  const scheduleGlass = function () {
    if (glassTimer) return;
    glassTimer = setTimeout(function () {
      glassTimer = null;
      renderBox();
    }, 0);
  };
  // document 级观察: 树变化(SPA 换品/换图/新 map script) + aria-hidden(图切换)
  new MutationObserver(scheduleGlass).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });

  scheduleGlass(); // 初次
})();